"use strict";

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActivityHandler = _interopRequireDefault(require("./ActivityHandler"));

var _util = require("./util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _awaitAsyncGenerator(value) {
  return new _AwaitValue(value);
}

function _wrapAsyncGenerator(fn) {
  return function () {
    return new _AsyncGenerator(fn.apply(this, arguments));
  };
}

function _AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof _AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume("next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen.return !== "function") {
    this.return = undefined;
  }
}

if (typeof Symbol === "function" && Symbol.asyncIterator) {
  _AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
    return this;
  };
}

_AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

_AsyncGenerator.prototype.throw = function (arg) {
  return this._invoke("throw", arg);
};

_AsyncGenerator.prototype.return = function (arg) {
  return this._invoke("return", arg);
};

function _AwaitValue(value) {
  this.wrapped = value;
}

function _asyncIterator(iterable) {
  var method;

  if (typeof Symbol !== "undefined") {
    if (Symbol.asyncIterator) {
      method = iterable[Symbol.asyncIterator];
      if (method != null) return method.call(iterable);
    }

    if (Symbol.iterator) {
      method = iterable[Symbol.iterator];
      if (method != null) return method.call(iterable);
    }
  }

  throw new TypeError("Object is not async iterable");
}
/* babel-plugin-inline-import './activity-triples.sparql' */


var queryTemplate = "SELECT ?subject ?predicate ?object WHERE {\n  ?subject a _:type;\n      <https://www.w3.org/ns/activitystreams#actor> _:actor;\n      <https://www.w3.org/ns/activitystreams#object> _:object.\n  ?subject ?predicate ?object.\n}\n";
var components = ['?subject', '?predicate', '?object'];
/**
 * Handler that deletes an activity in the user's data pod
 * Requires:
 * - the `root.user` handler
 * - the `root[...]` resolver
 * - a queryEngine property in the path settings
 */

var DeleteActivityHandler =
/*#__PURE__*/
function (_ActivityHandler$defa) {
  _inherits(DeleteActivityHandler, _ActivityHandler$defa);

  function DeleteActivityHandler() {
    _classCallCheck(this, DeleteActivityHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeleteActivityHandler).apply(this, arguments));
  }

  _createClass(DeleteActivityHandler, [{
    key: "createResults",
    // Finds activity triples for deletion
    value: function createResults(activity, document, queryEngine) {
      return _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _value;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = (0, _util.replaceVariables)(queryTemplate, activity);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 3;
                _loop =
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _loop() {
                  var triple, terms;
                  return _regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          triple = _value;
                          terms = components.map(function (c) {
                            return (0, _util.termToString)(triple.get(c));
                          });
                          _context.next = 4;
                          return "".concat(terms.join(' '), ".\n");

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });
                _iterator = _asyncIterator(queryEngine.execute(query, document));

              case 6:
                _context2.next = 8;
                return _awaitAsyncGenerator(_iterator.next());

              case 8:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 12;
                return _awaitAsyncGenerator(_step.value);

              case 12:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 18;
                  break;
                }

                return _context2.delegateYield(_loop(), "t0", 15);

              case 15:
                _iteratorNormalCompletion = true;
                _context2.next = 6;
                break;

              case 18:
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t1 = _context2["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 29;
                return _awaitAsyncGenerator(_iterator.return());

              case 29:
                _context2.prev = 29;

                if (!_didIteratorError) {
                  _context2.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context2.finish(29);

              case 33:
                return _context2.finish(24);

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, null, [[3, 20, 24, 34], [25,, 29, 33]]);
      }))();
    } // Deletes the activity triples from the document

  }, {
    key: "processResults",
    value: function () {
      var _processResults = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(results, document, queryEngine) {
        var sparql;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sparql = "DELETE {\n".concat(results.join(''), "}");
                _context3.next = 3;
                return queryEngine.executeUpdate(sparql, document).next();

              case 3:
                return _context3.abrupt("return", []);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }));

      function processResults(_x, _x2, _x3) {
        return _processResults.apply(this, arguments);
      }

      return processResults;
    }()
  }]);

  return DeleteActivityHandler;
}(_ActivityHandler.default);

exports.default = DeleteActivityHandler;